module.exports = __webpack_public_path__ + "img/67c7c8c.jpg";